import { LoggerMain } from "./classes/LoggerMain";
import winston from "winston";
import config from "./config";

let logger: LoggerMain | null = null;

export const getOrCreateMainLogger = () => {
	if (logger) return logger;

	const winstonLogger = winston.createLogger(config);
	logger = new LoggerMain(winstonLogger);
	return logger;
};
